import { Fragment, useContext } from 'react'
import { useParams } from 'react-router'
import { Alert, Box, Button, Grid, Typography } from '@mui/material'

import StickyHeader from '../../../components/sticky-header'
import useDates from '../../../utils/hooks/useDates'
import useIsMobile from '../../../utils/hooks/useIsMobile'
import OrderHistoryContext from '../context'
import useStyles from '../index.styles'

import OrderLoading from './order-loading'

const Order = () => {
  const classes = useStyles
  const isMobile = useIsMobile()
  const { formatDateTimeShortMonth } = useDates()
  const { order, loading } = useContext(OrderHistoryContext)
  const { orderNumber } = useParams<{ orderNumber: string }>()

  if (!orderNumber)
    return (
      <Alert severity="info" sx={classes.noHistoryAlert}>
        No order was selected.
      </Alert>
    )

  if ((loading && orderNumber && !order) || !order) return <OrderLoading />

  return (
    <Grid sx={classes.orderDetailsContainer}>
      <StickyHeader zIndex={1300} includeTopCover={true}>
        <Grid container={true} size={12} sx={classes.orderDetailsHeader}>
          <Grid container={true} sx={classes.orderDetailsHeaderColumn}>
            <Typography variant="caption" sx={classes.secondaryText}>
              {order.orderStatus}
            </Typography>

            {order.orderNumber && <Typography variant="body1">#{order.orderNumber}</Typography>}

            <Typography variant="body2" sx={classes.secondaryText}>
              Updated:
              <br />
              {formatDateTimeShortMonth(order.lastUpdated)}
            </Typography>
          </Grid>

          <Grid>
            {!['delivered', 'delivery exception', 'cancelled'].includes(order.orderStatus.toLowerCase()) && order.trackingUrl && (
              <Button
                variant="contained"
                size="small"
                color="secondary"
                disableElevation
                href={order.trackingUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={classes.trackShipmentButton}
              >
                Track Shipment
              </Button>
            )}
          </Grid>
        </Grid>
      </StickyHeader>

      <Grid container={true} size={12} sx={classes.orderListContainer}>
        <Typography variant="subtitle1" sx={classes.orderListTitle}>
          Order List
        </Typography>

        <Box sx={classes.orderListGrid(order.orderItems.length)}>
          <Typography variant="body2" sx={classes.orderListHeaderQuantity}>
            {isMobile ? 'Qty' : 'Quantity'}
          </Typography>
          <Typography variant="body2" sx={classes.orderListHeaderItem}>
            Item
          </Typography>

          {order.orderItems.map((item, index) => (
            <Fragment key={index}>
              <Typography variant="body2" sx={classes.orderListQuantityText}>
                {item.quantity}
              </Typography>
              <Typography variant="body2" sx={classes.orderListItemText}>
                {item.sku}
              </Typography>
            </Fragment>
          ))}
        </Box>
      </Grid>
    </Grid>
  )
}

export default Order
